var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61479E"
    },
    d: "M235.2,40.8c-7.2,0-14.4,4-17.6,10.4L80.8,128.8C64,123.2,44.8,120,36,120h-3.2 C15.2,120,0,134.4,0,152.8v190.4C0,361.6,15.2,376,32.8,376h2.4c8.8,0,28-3.2,44.8-8.8l136.8,77.6c3.2,6.4,10.4,10.4,18.4,10.4 c11.2,0,20.8-8.8,20.8-20V60.8C256,49.6,246.4,40.8,235.2,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A61C9"
    },
    d: "M216,52.8L216,52.8l-136,76c-17.6-5.6-35.2-8.8-44-8.8h-3.2C15.2,120,0,134.4,0,152.8V256h185.6 c18.4,0,30.4-17.6,30.4-35.2V52.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M305.6,324c-4,0-8-1.6-11.2-4.8c-5.6-5.6-5.6-16,0-21.6c28-28,28-72.8,0-100c-5.6-5.6-5.6-16,0-21.6 s16-5.6,21.6,0c39.2,39.2,39.2,104,0,143.2C312.8,322.4,308.8,324,305.6,324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M355.2,384.8c-4,0-8-1.6-11.2-4.8c-5.6-5.6-5.6-16,0-21.6c29.6-29.6,46.4-68.8,46.4-111.2 c0-41.6-16-81.6-46.4-111.2c-5.6-5.6-5.6-16,0-21.6s16-5.6,21.6,0c35.2,35.2,55.2,82.4,55.2,132.8s-19.2,97.6-55.2,132.8 C362.4,384,358.4,384.8,355.2,384.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M402.4,452c-4,0-8-1.6-11.2-4.8c-5.6-5.6-5.6-16,0-21.6c47.2-47.2,73.6-111.2,73.6-178.4 s-26.4-130.4-73.6-178.4c-5.6-5.6-5.6-16,0-21.6s16-5.6,21.6,0C466.4,101.6,496,172.8,496,248s-29.6,146.4-82.4,200 C410.4,450.4,406.4,452,402.4,452z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BA00"
    },
    d: "M308.8,320c39.2-39.2,39.2-104,0-143.2c-1.6-1.6-4.8-3.2-7.2-4c-2.4,0.8-4.8,1.6-7.2,4 c-5.6,5.6-5.6,16,0,21.6c28,28,28,72.8,0,100c-5.6,5.6-5.6,16,0,21.6c2.4,2.4,4.8,3.2,7.2,4C304,323.2,306.4,321.6,308.8,320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BA00"
    },
    d: "M358.4,380.8c35.2-35.2,55.2-82.4,55.2-132.8s-19.2-97.6-55.2-132.8c-2.4-2.4-4.8-3.2-7.2-4 c-2.4,0.8-4.8,1.6-7.2,4c-5.6,5.6-5.6,16,0,21.6c29.6,29.6,46.4,68.8,46.4,111.2c0,41.6-16,81.6-46.4,111.2c-5.6,5.6-5.6,16,0,21.6 c2.4,2.4,4.8,3.2,7.2,4C353.6,384,356,382.4,358.4,380.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64BA00"
    },
    d: "M405.6,448c53.6-53.6,82.4-124.8,82.4-200s-28.8-146.4-82.4-200c-1.6-2.4-4.8-3.2-7.2-4 c-2.4,0.8-4.8,1.6-7.2,4c-5.6,5.6-5.6,16,0,21.6c47.2,47.2,73.6,111.2,73.6,178.4s-26.4,130.4-73.6,178.4c-5.6,5.6-5.6,16,0,21.6 c2.4,2.4,4.8,3.2,7.2,4C400.8,451.2,404,449.6,405.6,448z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.19ddb053491c0cd0c952314f1b68dac9.svg";
export { ForwardRef as ReactComponent };